module.exports = __webpack_public_path__ + "static/1-f17ee66736be1aa16910f2779740818f.jpg";